function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3 5.996a1 1 0 011-1h12a1 1 0 011 1v.67a.5.5 0 01-.303.46l-6.303 2.701a1 1 0 01-.788 0L3.303 7.126A.5.5 0 013 6.666v-.67z",
  fill: "inherit"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 9.754a.5.5 0 01.697-.46l5.91 2.533a1 1 0 00.787 0l5.909-2.532a.5.5 0 01.697.46v6.241a1 1 0 01-1 1H4a1 1 0 01-1-1V9.754z",
  fill: "inherit"
});

var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "#A7AEB7"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0iI0E3QUVCNyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgNS45OTYwOUMzIDUuNDQzODEgMy40NDc3MiA0Ljk5NjA5IDQgNC45OTYwOUgxNkMxNi41NTIzIDQuOTk2MDkgMTcgNS40NDM4MSAxNyA1Ljk5NjA5VjYuNjY2NEMxNyA2Ljg2NjQxIDE2Ljg4MDggNy4wNDcxOCAxNi42OTcgNy4xMjU5N0wxMC4zOTM5IDkuODI3MjdDMTAuMTQyNCA5LjkzNTA4IDkuODU3NjMgOS45MzUwOCA5LjYwNjA4IDkuODI3MjdMMy4zMDMwNCA3LjEyNTk3QzMuMTE5MiA3LjA0NzE4IDMgNi44NjY0MSAzIDYuNjY2NFY1Ljk5NjA5WiIgZmlsbD0iaW5oZXJpdCIvPgo8cGF0aCBkPSJNMyA5Ljc1NDM2QzMgOS4zOTU0MSAzLjM2NzAzIDkuMTUzMzkgMy42OTY5NiA5LjI5NDc5TDkuNjA2MDggMTEuODI3M0M5Ljg1NzYzIDExLjkzNTEgMTAuMTQyNCAxMS45MzUxIDEwLjM5MzkgMTEuODI3M0wxNi4zMDMgOS4yOTQ3OUMxNi42MzMgOS4xNTMzOSAxNyA5LjM5NTQxIDE3IDkuNzU0MzZWMTUuOTk2MUMxNyAxNi41NDg0IDE2LjU1MjMgMTYuOTk2MSAxNiAxNi45OTYxSDRDMy40NDc3MiAxNi45OTYxIDMgMTYuNTQ4NCAzIDE1Ljk5NjFWOS43NTQzNloiIGZpbGw9ImluaGVyaXQiLz4KPC9zdmc+Cg==";
export { SvgSecurity as ReactComponent };